import { useState, useContext } from 'react';
import { Button } from 'react-bootstrap';

import LocationFilter from '../Filters/LocationFilter';
import ServicePeriodFilter from '../Filters/ServicePeriodFilter';
import AddBookingModal from '../../../../bookingmanagement/components/AddBooking/AddBookingModal';
import { ConfigContext } from '../../../../../contexts/ConfigContext';

import './headerRight.css';

export default function HeaderRightActions({ onSearchChange }) {
  const config = useContext(ConfigContext);
  const [showAddBooking, setShowAddBooking] = useState(false);

  return (
    <>
      <div className="d-flex flex-wrap gap-2 align-items-center">
        <LocationFilter />
        <ServicePeriodFilter />

        {/* SEARCH */}
        {/* <input
          type="text"
          placeholder="Search bookingid/ name/ phone"
          className="calendar-search-input "
          onChange={(e) => onSearchChange(e.target.value)}
        /> */}

        <Button size="md" variant={config.mode === 'dark' ? 'outline-light' : 'outline-dark'} onClick={() => setShowAddBooking(true)}>
          + Add Booking
        </Button>
      </div>

      {showAddBooking && <AddBookingModal show={showAddBooking} onClose={() => setShowAddBooking(false)} />}
    </>
  );
}
